import React from "react";
import { NotificationContainer } from "components/Header/styles";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import useNotificationCountQuery from "hooks/queries/notification/useNotificationCountQuery";
import useModal from "hooks/useModal";
import NotificationModal from "components/Header/Notification/NotificationModal";
import { getIsUser } from "utils/utility";

function Notification() {
  const isUser = getIsUser();
  const { data: notificationCount, isFetching } =
    useNotificationCountQuery(isUser);

  const {
    isOpen: isOpenNotificationModal,
    openModal: openNotificationModal,
    closeModal: closeNotificationModal,
  } = useModal();

  return (
    <>
      <NotificationContainer onClick={openNotificationModal}>
        <NotificationsOutlinedIcon className="icon" />
        {!isFetching && isUser && (
          <div className="countContainer">
            <div className="count">
              {notificationCount
                ? notificationCount.count > 999
                  ? "999+"
                  : notificationCount.count
                : 0}
            </div>
          </div>
        )}
      </NotificationContainer>
      {isOpenNotificationModal && (
        <NotificationModal
          totalCount={notificationCount?.count || null}
          modalClose={closeNotificationModal}
        />
      )}
    </>
  );
}

export default Notification;
